export default __webpack_public_path__ + "static/media/api-videogames-logo-c.df5f8b34.png";